const initialState = {
    menuItems: [],
    banners: [],
    subMenuItems: [],
    isSubMenuFetched: false,
    isMenuFetched: false,
    loading: false,
    error: null,
  };
  
  const mainMenuReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_MENU_LOADING":
        return { ...state, loading: action.data };
  
      case "SET_MENU_ITEMS":
        return {
          ...state,
          menuItems: action.data.menu_items,
          banners: action.data.banners,
          isMenuFetched: true,
          error: null,
        };
  
      case "SET_INNER_MENU_ITEMS":
        return {
          ...state,
          subMenuItems: action.data.menu_items,
          isSubMenuFetched: true,
          error: null,
      };
      case "SET_MENU_ERROR":
        return { ...state, error: action.data };
   
      default:
        return state;
    }
  };
  
  export default mainMenuReducer;
  